import {
  createContext,
  type SetStateAction,
  type Dispatch,
  type Context,
} from 'react';

type MenuSubContextProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isDefaultOpen: boolean;
};

export const MenuSubContext: Context<MenuSubContextProps> =
  createContext<MenuSubContextProps>({
    isOpen: false,
    isDefaultOpen: false,
    setIsOpen: () => null,
  });
